export default __webpack_public_path__ + "static/5-7d874689d4447773cd45f5be849abfdb.jpeg";